(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function () {
    const availabilityParam = 'filter.v.availability';
    const showAllParam = 'show_sold_out';
    const storageKey = 'collection_show_sold_out';

    function getStorageValue() {
      try {
        return window.sessionStorage.getItem(storageKey);
      } catch (error) {
        return null;
      }
    }

    function setStorageValue(value) {
      try {
        window.sessionStorage.setItem(storageKey, value);
      } catch (error) {
        // Continue without session storage if unavailable.
      }
    }

    function initialiseCollectionAvailability() {
      const url = new URL(window.location.href);
      const isShowingSoldOut = url.searchParams.get(showAllParam) === '1';
      const userPreference = getStorageValue();

      if (isShowingSoldOut) {
        setStorageValue('true');
        url.searchParams.delete(showAllParam);
        url.searchParams.delete(availabilityParam);
        window.history.replaceState({}, '', url.toString());
        return;
      }

      if (!url.searchParams.has(availabilityParam) && userPreference !== 'true') {
        url.searchParams.set(availabilityParam, '1');
        window.location.replace(url.toString());
      }
    }

    function initialiseAvailabilityToggle() {
      const container = document.querySelector('[data-availability-toggle-container]');
      const button = document.querySelector('[data-availability-toggle]');

      if (!container || !button) return;

      const url = new URL(window.location.href);
      const inStockOnly = url.searchParams.has(availabilityParam);

      button.textContent = inStockOnly
        ? 'Show sold-out products'
        : 'Hide sold-out products';

      button.setAttribute(
        'aria-pressed',
        inStockOnly ? 'false' : 'true'
      );

      button.addEventListener('click', function () {
        const nextUrl = new URL(window.location.href);

        if (nextUrl.searchParams.has(availabilityParam)) {
          nextUrl.searchParams.delete(availabilityParam);
          nextUrl.searchParams.set(showAllParam, '1');
          setStorageValue('true');
        } else {
          nextUrl.searchParams.set(availabilityParam, '1');
          nextUrl.searchParams.delete(showAllParam);
          setStorageValue('false');
        }

        nextUrl.searchParams.delete('page');
        window.location.assign(nextUrl.toString());
      });

      container.hidden = false;
    }

    const url = new URL(window.location.href);

    if (url.hash) {
      document.addEventListener(
        'DOMContentLoaded',
        () => {
          const card = document.getElementById(url.hash.slice(1));

          if (card) {
            card.scrollIntoView({ behavior: 'instant' });
          }
        },
        { once: true }
      );
    }

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        function () {
          initialiseCollectionAvailability();
          initialiseAvailabilityToggle();
        },
        { once: true }
      );
    } else {
      initialiseCollectionAvailability();
      initialiseAvailabilityToggle();
    }

    document.addEventListener('shopify:section:load', function () {
      initialiseAvailabilityToggle();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
